<template>
  <v-container fluid>
    <v-row>
      <v-btn class="ma-3" color="primary" @click="openCreate">
        <v-icon left>mdi-plus</v-icon>
        Neue Routine
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn class="ma-3" icon :loading="loading" @click="load">
        <v-icon>mdi-reload</v-icon>
      </v-btn>
    </v-row>
    <v-row>
      <v-col
          v-for="routine in routines"
          :key="routine.id"
          cols="12"
          sm="6"
          md="6"
          lg="4"
          xl="3"
      >
        <RoutineCard :routine="routine" @changed="onChanged" @edit="openEdit"></RoutineCard>
      </v-col>
    </v-row>
    <v-row v-if="!loading && routines.length === 0">
      <v-col class="text--secondary">
        Noch keine Routinen — über „Neue Routine“ Aktionslisten anlegen.
        Platzierte Routinen lassen sich als Trigger auf der Schnuffel-Karte umschalten.
      </v-col>
    </v-row>

    <RoutineEditDialog
        v-model="editorOpen"
        :routine="editing"
        :devices="devices"
        @save="save"
    ></RoutineEditDialog>
  </v-container>
</template>

<script>
import RoutineCard from './model/RoutineCard'
import RoutineEditDialog from './model/RoutineEditDialog'
import { smarthausApi } from '../../services/smarthaus'

export default {
  name: 'RoutineView',
  components: { RoutineCard, RoutineEditDialog },
  data: () => ({
    routines: [],
    devices: [],
    loading: false,
    editorOpen: false,
    editing: null, // null = neu anlegen
  }),
  mounted() {
    this.load()
  },
  methods: {
    async load() {
      this.loading = true
      try {
        const [routinesData, devicesData] = await Promise.all([
          smarthausApi.routines(),
          smarthausApi.devices(),
        ])
        this.routines = routinesData.routines
        this.devices = devicesData.devices
      } catch (e) {
        console.error('[RoutineView]', e)
      } finally {
        this.loading = false
      }
    },
    openCreate() {
      this.editing = null
      this.editorOpen = true
    },
    openEdit(routine) {
      this.editing = routine
      this.editorOpen = true
    },
    async save(payload) {
      try {
        if (this.editing) await smarthausApi.routineUpdate(this.editing.id, payload)
        else await smarthausApi.routineCreate(payload)
      } catch (e) {
        console.error('[RoutineView] save', e)
      }
      this.load()
    },
    onChanged(routine) {
      if (routine) {
        const index = this.routines.findIndex((r) => r.id === routine.id)
        if (index !== -1) {
          this.routines.splice(index, 1, routine)
          return
        }
      }
      this.load()
    },
  },
}
</script>

<style scoped>

</style>
